import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  IconButton,
} from "@mui/material";
import { useSocialMediaThemes } from "../api/getSocialMediaThemes";
import { baseUrl } from "../../../shared/config";
import { useTheme } from "@emotion/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Cancel, Home, Policy } from "@mui/icons-material";
import clsx from "clsx";
import _cookies from "../../../shared/utils/_cookies";
import { useTenantParameters } from "../../misc/api/getTenantParameters";

export default function SocialMediaThemes({}) {
  const { data } = useSocialMediaThemes();
  const tenantParamsQ = useTenantParameters();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const theme = useTheme();
  const handleClickItem = (item) => () => {
    if (item == null) {
      navigate("../social");
      return;
    }
    navigate(`../social/tema/${item.TEMAID}`);
  };

  const isThemeSelected = (themeId) => {
    if (theme)
      return themeId === params.themeId || themeId === Number(params.themeId);
  };

  const showModerationButtons = () => {
    if (
      tenantParamsQ.data?.EXIGIR_APROVACAO_REDE_SOCIAL === "S" &&
      _cookies.getItem("auth").user?.profile?.isGestor?.ID
    ) {
      return true;
    }
    return false;
  };

  return (
    <List
      disablePadding
      className="themes_list"
      sx={{
        ".avatar_bordered": {
          border: `2.5px solid ${theme.palette.secondary.main}`,
          backgroundColor: "primary.main",
        },
        ".themes_list_item": {
          cursor: "pointer",
        },
      }}
    >
      <ListItem
        className="themes_list_item"
        disablePadding
        sx={{ paddingY: 1 }}
        onClick={handleClickItem(null)}
      >
        <ListItemAvatar>
          <Avatar className={clsx({ avatar_bordered: isThemeSelected() })}>
            <Home color="primary.main" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primaryTypographyProps={{
            variant: "subtitle2",
            sx: {
              fontWeight: isThemeSelected() ? "bold" : "500",
            },
          }}
          className={clsx({ "font-bold": isThemeSelected() })}
        >
          Feed geral
        </ListItemText>
        {showModerationButtons() &&
          (isThemeSelected("0") && location.pathname.includes("moderar") ? (
            <>
              <IconButton
                href={`/aluno/social/tema/0`}
                variant="outlined"
                color="error"
              >
                <Cancel />
              </IconButton>
            </>
          ) : (
            <IconButton
              href={`/aluno/social/tema/0/moderar`}
              variant="outlined"
            >
              <Policy />
            </IconButton>
          ))}
      </ListItem>
      {data?.map((theme) => {
        return (
          <ListItem
            className="themes_list_item"
            disablePadding
            sx={{ paddingY: 1 }}
            onClick={handleClickItem(theme)}
          >
            <ListItemAvatar className="themes_list_item_avatar">
              <Avatar
                src={`${baseUrl}/membros/fotos/${theme?.FOTO}`}
                className={clsx({
                  avatar_bordered: isThemeSelected(theme.TEMAID),
                })}
              />
            </ListItemAvatar>
            <ListItemText
              primaryTypographyProps={{
                variant: "subtitle2",
                sx: {
                  fontWeight: isThemeSelected(theme.TEMAID) ? "bold" : "500",
                },
              }}
            >
              {theme.NOME}
            </ListItemText>
            {showModerationButtons() &&
              (isThemeSelected(theme?.TEMAID) &&
              location.pathname.includes("moderar") ? (
                <>
                  <IconButton
                    href={`/aluno/social/tema/${theme?.TEMAID}`}
                    variant="outlined"
                    color="error"
                  >
                    <Cancel />
                  </IconButton>
                </>
              ) : (
                <IconButton
                  href={`/aluno/social/tema/${theme?.TEMAID}/moderar`}
                  variant="outlined"
                >
                  <Policy />
                </IconButton>
              ))}
          </ListItem>
        );
      })}
    </List>
  );
}
